export const QUERIES = {
  FILE_PREVIEW_LOAD_SOURCE: 'file-preview-load',
  REPORT_INVENTORY_STOCK: 'report-inventory-stock',
  USER_PROFILE: 'user-profile',
  GENERATE_TWO_FA: 'generate-two-fa',
  USER_ME: 'user-me',
  USERS_LIST: 'users-list',
  USER_DETAIL: 'users-detail',
  COMPANIES_LIST: 'companies-list',
  COMPANY_DETAIL: 'company-detail',
  ASSIGNED_CLINIC_LIST: 'assigned-clinic-list',
  CLINIC_LIST: 'clinic-list',
  CLINIC_TYPE: 'clinic-type',
  CLINIC_DETAIL: 'clinic-detail',
  COUNTRIES_LIST: 'countries-type',
  DOCTOR_LIST: 'doctors-list',
  DOCTOR_DETAIL: 'doctor-detail',
  GET_DOCTOR_OPTIONS_FOR_BOOKING_FORM: 'get-doctor-options-for-booking-form',
  GET_ADMIN_QUALIFICATION_LIST: 'get-admin-qualifications-list',
  QUALIFICATION_DETAIL: 'qualification-detail',
  DOCTOR_QUALIFICATION_DETAIL: 'doctor-qualification-detail',
  ADMINISTRATIVE_DIVISIONS_LIST: 'administrative-divisions',
  GET_ADMIN_NURSE_LIST: 'get-admin-nurse-list',
  NURSE_LIST: 'nurse-list',
  ROLES_LIST: 'roles-list',
  NURSE_DETAIL: 'nurse-detail',
  QUEUES_LIST: 'queues-list',
  QUEUE_DETAIL: 'queue-detail',
  TASKS_LIST: 'tasks-list',
  TASK_DETAIL: 'task-detail',
  TASK_COMMENTS_LIST: 'task-comments-list',
  TASK_TODO_TOTAL: 'task-todo-total',
  TASK_ATTACHMENT_LIST: 'task-attachment-list',
  TASK_FLOATING_LIST: 'task-floating-list',
  APPOINTMENTS_LIST: 'appointments-list',
  APPOINTMENT_DETAIL: 'appointment-detail',
  APPOINTMENT_TYPES_LIST: 'appointment-types-list',
  APPOINTMENT_TYPE_DETAIL: 'appointment-type-detail',
  PATIENT_VISIT_LIST: 'patient-visit-list',
  PATIENT_VISIT_LIST_MEDICAL_RECORD: 'patient-visit-list-medical-record',
  PATIENT_VISIT_DETAIL: 'patient-visit-detail',
  QUEUE_DISPLAY_LIST: 'queue-display-list',
  QUEUE_DISPLAY_DETAIL: 'queue-display-detail',
  QUEUE_PROCESS: 'queue-process',
  QUEUE_DISPLAY_PRESENT: 'queue-display-present',
  QUEUE_DISPLAY_BANNER: 'queue-display-banner',
  QUEUE_DISPLAY_RUNNING_TEXT: 'queue-display-running-text',
  QUEUE_DISPLAY_QUEUE: 'queue-display-queue',
  QUEUE_SESSION: 'queue-session',
  PATIENT_VITAL_CHECKS_LIST: 'patient-vital-checks-list',
  PATIENT_VITAL_CHECK_DETAIL: 'patient-vital-check-detail',
  PATIENT_VITAL_CHECK_LATEST: 'patient-vital-check-latest',
  CLINIC_SETTINGS_LIST: 'clinic-settings-list',
  PATIENT_INTERVIEWS: 'patient-interviews',
  PATIENT_INTERVIEW_DETAIL: 'patient-interview-detail',
  PATIENT_VITAL_FOR_MEDICAL_RECORD: 'patient-vital-for-medical-record',
  PATIENT_VITAL_VISUALIZE: 'patient-vital-visualize',
  PATIENT_VITAL_DETAIL: 'patient-vital-detail',
  PATIENT_DETAIL: 'patient-detail',
  PATIENT_SUMMARY: 'patient-summary',
  PATIENT_MEDICAL_NOTE: 'patient-medical-note',
  QUEUE_NUMBER_CURRENT: 'queue-number-current',
  QUEUE_NUMBER_DETAIL: 'queue-number-detail',
  PATIENT_INFORMATION_DETAIL: 'patient-information-detail',
  GET_PATIENT_DISEASE_LIST: 'get-patient-disease-list',
  GET_PATIENT_DISEASE_DETAIL: 'get-patient-disease-detail',
  WHITELIST_IP_LIST: 'whitelist-ip-list',
  PATIENT_DOCTOR_LIST: 'patient-doctor-list',
  PATIENT_DOCTOR_LIST_SUMMARY: 'patient-doctor-list-summary',
  PATIENT_MEDICINE_HISTORIES: 'patient-medicine-histories',
  PATIENT_MEDICINE_HISTORIES_DETAIL: 'patient-medicine-histories-detail',
  PATIENT_MEDICINE_ALLERGIES: 'patient-medicine-allergies',
  PATIENT_MEDICINE_ALLERGIES_DETAIL: 'patient-medicine-allergies-detail',
  PATIENT_ALLERGIES: 'patient-alergies',
  PATIENT_ALLERGIES_DETAIL: 'patient-allergies-detail',
  PRINTER_GATEWAY_LIST: 'printer-gateway-list',
  PRINTER_GATEWAY_DETAIL: 'printer-gateway-detail',
  PRINTER_GATEWAY_PRINTERS_LIST: 'printer-gateway-printers-list',
  PATIENT_TEST_RESULTS: 'patient-test-results',
  PATIENT_TEST_RESULT_DETAIL: 'patient-test-result-detail',
  EXAMINATION_LIST: 'examination-list',
  GET_ADMIN_EXAMINATION_OPTIONS: 'get-admin-examination-options',
  GET_EXAMINATION_DETAIL: 'get-examination-detail',
  GET_ADMIN_EXAMINATION_DETAIL: 'get-admin-examination-detail',
  GET_TREATMENT_LIST: 'get-treatment-list',
  GET_ADMIN_TREATMENT_OPTIONS: 'get-admin-treatment-options',
  GET_TREATMENT_DETAIL: 'get-treatment-detail',
  GET_ADMIN_TREATMENT_DETAIL: 'get-admin-treatment-detail',
  GET_MEDICINAL_CLASSIFICATION_LIST: 'get-medicinal-classification-list',
  ICD10_TRENDINGS_LIST: 'icd10-trendings-list',
  GET_MEDICINE_FORM_LIST: 'get-medicine-form-list',
  MEDICINE_FORM_DETAIL: 'medicine-form-detail',
  GET_MEDICINAL_ROUTE_LIST: 'get-medicinal-route-list',
  GET_MEDICINAL_CONTROLLED_DRUG_CLASSIFICATION: 'medicinal-controlled-drug-classification',
  GET_MEDICINAL_CATEGORY_LIST: 'get-medicinal-category-list',
  GET_MEDICINAL_ATTENTION_LIST: 'get-medicinal-attention-list',
  MEDICINAL_ATTENTION_DETAIL: 'medicinal-attention-detail',
  GET_MEDICINAL_INSTRUCTION_LIST: 'get-medicinal-instruction-list',
  MEDICINAL_INSTRUCTION_DETAIL: 'medicinal-instruction-detail',
  UNIT_LIST: 'unit-list',
  MEDICINE_LIST: 'medicine-list',
  GET_MEDICINE_DETAIL: 'get-medicine-detail',
  GET_ADMIN_MEDICINE_DETAIL: 'get-admin-medicine-detail',
  INJECTION_LIST: 'injection-list',
  GET_INJECTION_DETAIL: 'get-injection-detail',
  GET_ADMIN_INJECTION_DETAIL: 'get-admin-injection-detail',
  VACCINE_LIST: 'vaccine-list',
  VACCINE_DETAIL: 'vaccine-detail',
  GET_VIRTUAL_THERAPEUTIC_MOIETY_LIST: 'get-virtual-therapeutic-moiety-list',
  GET_VIRTUAL_THERAPEUTIC_MOIETY_DETAIL: 'get-virtual-therapeutic-moiety-detail',
  GET_VIRTUAL_MEDICINAL_PRODUCT_DETAIL: 'get-virtual-medicinal-product-detail',
  GET_VIRTUAL_MEDICINAL_PRODUCT_LIST: 'get-virtual-medicinal-product-list',
  PATIENT_RELATIVES_LIST: 'patient-relatives-list',
  MEDICAL_RECORD: 'medical-record',
  MEDICAL_RECORD_TEMPLATE_LIST: 'medical-record-template-list',
  GET_MEDICAL_RECORD_TEMPLATE_OPTIONS: 'get-medical-record-template-options',
  GET_MEDICAL_RECORD_TEMPLATE_DETAIL: 'get-medical-record-template-detail',
  MEDICAL_RECORD_LIST: 'medical-record-list',
  MEDICAL_RECORD_MEDICINE_LIST: 'medical-record-medicine-list',
  MEDICAL_RECORD_AMENDMENT_LIST: 'medical-record-amendment-list',
  VACCINATION_LIST: 'vaccination-list',
  VACCINATION_DETAIL: 'vaccination-detail',
  PATIENT_DOCUMENT_LIST: 'patient-document-list',
  PATIENT_DOCUMENT_DETAIL: 'patient-document-detail',
  TELECONSULT_LIST: 'teleconsult-list',
  TELECONSULT_DETAIL: 'teleconsult-detail',
  PATIENT_VISIT_SUMMARY_LIST: 'patient-visit-summary-list',
  GET_MEDICAL_RECORD_PERMISSIONS: 'get-medical-record-permissions',
  CASHIERS_LIST: 'cashiers-list',
  CASHIER_DETAIL: 'cashier-detail',
  GET_CASHIER_SESSION_LIST: 'get-cashier-session-list',
  GET_CASHIER_SESSION_DETAIL: 'get-cashier-session-detail',
  MEDICAL_CART_ACTIVE: 'medical-cart-active',
  GET_CASHIER_SESSION: 'get-cashier-session',
  GET_CASHIER_SESSION_ACTIVE: 'get-cashier-session-active',
  GLOBAL_SETTING_LIST: 'global-setting-list',
  GET_CASHIER_DAILY_RECORD: 'get-cashier-daily-record',
  GET_SALES_PAYMENT: 'get-sales-payment',
  GET_ADMIN_PHARMACIST_LIST: 'get-admin-pharmacist-list',
  PHARMACIST_LIST: 'pharmacist-list',
  PHARMACIST_DETAIL: 'pharmacist-detail',
  GET_MEDICINAL_DISPENSE_FOR_UPDATE: 'get-medicinal-dispense-for-update',
  GET_MEDICINAL_DISPENSE_LIST: 'get-medicinal-dispense-list',
  GET_MEDICINAL_DISPENSE_DETAIL: 'get-medicinal-dispense-detail',
  GET_MEDICINAL_DISPENSE_DOWNLOAD: 'get-medicinal-dispense-download',
  MEDICINAL_DISPENSE_GET_CHECK: 'medicinal-dispense-get-check',
  CLINIC_OTTOPAY_EDC_LIST: 'clinic-ottopay-edc-list',
  CLINIC_OTTOPAY_EDC_DETAIL: 'clinic-ottopay-edc-detail',
  CART_ACTIVE: 'cart-active',
  RETAIL_CART_ACTIVE: 'retail-cart-active',
  GET_CART: 'get-cart',
  CASHIER_SALES_INVOICES_LIST: 'cashier-sales-invoices-list',
  CASHIER_SALES_INVOICE_DETAIL: 'cashier-sales-invoices-detail',
  GET_TREATMENT_CATEGORY: 'get-treatment-category',
  GET_TREATMENT_CATEGORY_LIST: 'get-treatment-category-list',
  GET_SUPPLIERS_LIST: 'get-suppliers-list',
  GET_SUPPLIER_DETAIL: 'get-supplier-detail',
  PRODUCT_RECEIVE_LIST: 'product-receive-list',
  PRODUCT_RECEIVE_DETAIL: 'product-receive-detail',
  GET_MEDICAL_TOOL_DETAIL: 'get-medicinal-tool-detail',
  GET_MEDICAL_TOOLS_LIST: 'get-medicinal-tools-list',
  GET_EXAMINATION_CATEGORY_LIST: 'get-examination-category-list',
  GET_RETAIL_CART: 'get-retail-cart',
  GET_ACTIVE_RETAIL_CART: 'get-active-retail-cart',
  GET_RETAIL_PRODUCT_LIST: 'get-retail-product-list',
  RETAIL_PRODUCT_CATEGORY_LIST: 'retail-product-category-list',
  GET_RETAIL_PRODUCT_CATEGORY: 'get-retail-product-category',
  GET_RETAIL_PRODUCT_DETAIL: 'get-retail-product-detail',
  GET_SALES_ACTIVE_RETAIL_CART: 'get-sales-active-retail-cart',
  BANK_LIST: 'bank-list',
  GET_BANK_DETAIL: 'get-bank-detail',
  GET_CASH_DEPOSIT_CASH_ON_HAND: 'get-cash-deposit-cash-on-hand',
  GET_CLUSTER_CASH_DEPOSIT_LIST: 'get-cluster-cash-deposit-list',
  GET_CLUSTER_CASH_DEPOSIT_IMAGE_FILE: 'get-cluster-cash-deposit-image-file',
  GET_CASH_DEPOSIT_IMAGE_FILE: 'get-cash-deposit-image-file',
  GET_CASH_DEPOSIT_LIST: 'get-cash-deposit-list',
  GET_CASHIER_SUMMARY_LIST: 'get-cashier-summary-list',
  GET_CASHIER_SUMMARY_FILTER_SUMMARIZED: 'get-cashier-summary-filter-summarized',
  POST_CASHIER_SUMMARIES_CSV_DOWNLOAD: 'post-cashier-summary-csv-download',
  GET_CASHIER_SUMMARY_DETAIL: 'get-cashier-summary-detail',
  GET_CLUSTER_MANAGER_CASHIER_SUMMARIES_LIST: 'get-cluster-manager-cashier-summary-list',
  GET_CLUSTER_MANAGER_CASHIER_SUMMARY_FILTER_SUMMARIZED: 'get-cluster-manager-cashier-summary-filter-summarized',
  POST_CLUSTER_MANAGER_CASHIER_SUMMARIES_CSV_DOWNLOAD: 'post-cluster-manager-cashier-summary-csv-download',
  GET_CLUSTER_MANAGER_CASHIER_SUMMARY_DETAIL: 'get-cluster-manager-cashier-summary-detail',
  GET_MEDICAL_RECORD_MEDICAL_TOOL_LIST: 'get-medical-record-medical-tool-list',
  GET_ADMIN_MEDICAL_TOOL_OPTIONS: 'get-admin-medical-tool-options',
  GET_PRODUCTS_OPTIONS_MEDICAL_RECORD: 'get-products-options-medical-record',
  GET_ADMIN_PRODUCT_OPTIONS: 'get-admin-product-options',
  GET_PRODUCT_OPTIONS_FOR_PRICE_TAG_DOWNLOAD: 'get-product-options-for-price-tag-download',
  GET_PRODUCT_ADJUSTMENT_LIST: 'get-product-adjustment-list',
  GET_PRODUCT_ADJUSTMENT_DETAIL: 'get-product-adjustment-list',
  GET_VOUCHER_GENERATE_RULE_LIST: 'get-voucher-generate-rule-list',
  GET_VOUCHER_GENERATE_RULE_DETAIL: 'get-voucher-generate-rule-detail',
  PRODUCT_TRANSFER_LIST: 'product-transfer-list',
  PRODUCT_TRANSFER_DETAIL: 'product-transfer-detail',
  GET_VOUCHER_CODE_LIST: 'get-voucher-code-list',
  GET_VOUCHER_CODE_DETAIL: 'get-vouher-code-detail',
  GET_VOUCHER_CODE_REDEEM_LIST: 'get-voucher-code-redeem-list',
  GET_PATIENT_SURGERY_LIST: 'get-patient-surgery-list',
  GET_PATIENT_SURGERY_DETAIL: 'get-patient-surgery-detail',
  PATIENT_CONGENITAL_DISEASE: 'patient-congenital-disease',
  GET_PATIENT_CONGENITAL_DISEASE_DETAIL: 'get-patient-congenital-disease-detail',
  GET_ACTIVE_QUEUE_SESSION: 'get-active-queue-session',
  GET_ACITVE_NPS: 'get-active-nps',
  GET_FINANCE_INVENTORY_REPORT_LIST: 'get-finance-inventory-report-list',
  GET_DAILY_TRANSACTION_REPORT_LIST: 'get-daily-transaction-report-list',
  GET_MONTHLY_REVENUE_REPORT_LIST: 'get-monthly-revenue-report-list',
  GET_NET_PROMOTER_SCORE_REPORT_LIST: 'get-net-promoter-score-report-list',
  GET_SERVICE_AND_PERFORMANCE_REPORT_LIST: 'get-service-and-performance-report-list',
  GET_SALES_REPORT_LIST: 'get-sales-report-list',
  PRODUCT_INVENTORY_LIST: 'product-inventory-list',
  GET_PRODUCT_INVENTORY_DETAIL: 'get-product-inventory-detail',
  GET_PRODUCT_INVENTORY_ACTIVITY_LOG_LIST: 'get-product-inventory-activity-log-list',
  GET_PRODUCT_INVENTORY_LIST_ACTIVITY_LOG_SUMMARIZED: 'get-product-inventory-list-activity-log-summarized',
  GET_MEDICAL_RECORD_LIST_STAND_BY: 'GET_MEDICAL_RECORD_LIST_STAND_BY',
  GET_ADMIN_PRODUCT_BUNDLING_LIST: 'get-admin-product-bundling-list',
  GET_ADMIN_PRODUCT_BUNDLING_DETAIL: 'get-admin-product-bundling-detail',
  GET_PRODUCT_BUNDLING_LIST: 'get-product-bundling-list',
  GET_PRODUCT_BUNDLING_DETAIL: 'get-product-bundling-detail',
  GET_PRODUCT_PROMOTION_LIST: 'GET_PRODUCT_PROMOTION_LIST',
  GET_PRODUCT_PROMOTION_DETAIL: 'get-product-promotion-detail',
  GET_CLINIC_MANAGER_SALES_INVOICE_LIST: 'GET_CLINIC_MANAGER_SALES_INVOICE_LIST',
  GET_MONTH_TO_DATE_SALES_REPORT_LIST: 'GET_MONTH_TO_DATE_SALES_REPORT_LIST',
  GET_PRODUCT_BUNDLING_OPTIONS_FOR_MEDICAL_RECORD: 'get-product-bundling-options-for-medical-record',
  GET_ADMIN_INSURANCE_PAYOR_LIST: 'get-admin-insurance-payor-list',
  GET_ADMIN_INSURANCE_PAYOR_DETAIL: 'get-admin-insurance-payor-detail',
  GET_INSURANCE_LIST: 'get-insurance-list',
  GET_INSURANCE_DETAIL: 'get-insurance-detail',
  MEDICINAL_DISPENSE_PRODUCTS_LIST: 'medicinal-dispense-products-list',
  GET_CLINIC_BOOKING_TIME: 'get-clinic-booking-time',
  GET_BOOKING_CALENDAR: 'get-booking-calendar',
  BOOKING_HOLIDAY_LIST: 'booking-holiday-list',
  GET_DOCTOR_BOOKING_TIME_OFF_DOCTORS_LIST: 'get-doctor-booking-time-off-doctors-list',
  GET_DOCTOR_BOOKING_TIME_OFF_DOCTOR_DETAIL: 'get-doctor-booking-time-off-doctor-detail',
  GET_DOCTOR_BOOKING_TIME_OFF_WITH_DOCTOR: 'get-doctor-booking-time-off-with-doctor',
  CLINIC_BOOKING_CLOSED_TIME_LIST: 'clinic-booking-closed-time-list',
  GET_CURRENT_CLINIC_BOOKING_TIME_WITH_DOCTOR: 'get-current-clinic-booking-time-with-doctor',
  GET_DOCTOR_BOOKING_TIME_SLOT_DOCTOR_LIST: 'get-doctor-booking-time-slot-doctor-list',
  GET_DOCTOR_BOOKING_TIME_SLOT_CLINIC_BOOKING_TIME: 'get-doctor-booking-time-slot-clinic-booking-time',
  ODONTOGRAM_RENDER_LIST: 'odontogram-render-list',
  ODONTOGRAM_ACTIVITY_LIST: 'odontogram-activity-list',
  GET_ODONTOGRAM_HISTORY: 'get-odontogram-history',
  PRODUCT_TRANSFER_CLINIC_INBOUND_LIST: 'product-transfer-clinic-inbound-list',
  GET_PRODUCT_TRANSFER_CLINIC_INBOUND_DETAIL: 'get-product-transfer-clinic-inbound-detail',
  GET_PRODUCT_TRANSFER_CLINIC_OUTBOUND_LIST: 'get-product-transfer-clinic-outbound-list',
  PRODUCT_TRANSFER_CLINIC_OUTBOUND_LIST: 'get-product-transfer-clinic-outbound-list',
  PRODUCT_TRANSFER_CLINIC_OUTBOUND_DETAIL: 'product-transfer-clinic-outbound-detail',
  ADMIN_RADIOGRAPHER_LIST: 'admin-radiographer-list',
  ADMIN_RADIOGRAPHER_DETAIL: 'admin-radiographer-detail',
  DIAGNOSTIC_ANCILLARY_LIST: 'diagnostic-ancillary-list',
  DIAGNOSTIC_ANCILLARY_DETAIL: 'diagnostic-ancillary-detail',
  ADMIN_CLIENT_CORPORATE_LIST: 'admin-client-corporate-list',
  ADMIN_CLIENT_CORPORATE_DETAIL: 'admin-client-corporate-detail',
  CLINIC_BOOKING_TIME_SLOT_OPTION_DATES_FOR_DIAGNOSTIC_ANCILLARY_FORM:
    'clinic-booking-time-slot-option-dates-for-diagnostic-ancillary-form',
  DIAGNOSTIC_ANCILLARY_ACTION_LIST: 'diagnostic-ancillary-action-list',
  DIAGNOSTIC_ANCILLARY_ACTION_DETAIL: 'diagnostic-ancillary-action-detail',
  DIAGNOSTIC_ANCILLARY_SUMMARY_LIST: 'diagnostic-ancillary-summary-list',
  DIAGNOSTIC_ANCILLARY_SUMMARY_DETAIL: 'diagnostic-ancillary-summary-detail',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_PHYSICAL_EXAMINATION: 'diagnostic-ancillary-examination-physical-examination',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_PHYSICAL_EXAMNATION_TEMP:
    'diagnostic-ancillary-examination-physical-examination-temp',
  DIAGNOSTIC_ANCILLARY_ODONTOGRAM_RENDER_LIST: 'diagnostic-ancillary-odontogram-render-list',
  DIAGNOSTIC_ANCILLARY_ODONTOGRAM_ACTIVITY_LIST: 'diagnostic-ancillary-odontogram-activity-list',
  DIAGNOSTIC_ANCILLARY_FILE_DENTAL_XRAY_LIST: 'diagnostic-ancillary-file-dental-xray-list',
  DIAGNOSTIC_ANCILLARY_FILE_EKG_LIST: 'diagnostic-ancillary-file-ekg-list',
  DIAGNOSTIC_ANCILLARY_FILE_USG_LIST: 'diagnostic-ancillary-file-usg-list',
  DIAGNOSTIC_ANCILLARY_FILE_ODONTOGRAM_LIST: 'diagnostic-ancillary-file-odontogram-list',
  DIAGNOSTIC_ANCILLARY_FILE_DENTAL_ECHO_LIST: 'diagnostic-ancillary-file-echo-list',
  DIAGNOSTIC_ANCILLARY_XRAY_LIST: 'diagnostic-ancillary-xray-list',
  DIAGNOSTIC_ANCILLARY_FILE_XRAY_LIST: 'diagnostic-ancillary-file-xray-list',
  DIAGNOSTIC_ANCILLARY_FILE_LABORATORY_LIST: 'diagnostic-ancillary-file-laboratory-list',
  DIAGNOSTIC_ANCILLARY_FILE_TREADMILL_LIST: 'diagnostic-ancillary-file-treadmill-list',
  DIAGNOSTIC_ANCILLARY_TEMPLATE_LIST: 'diagnostic-ancillary-template-list',
  DIAGNOSTIC_ANCILLARY_TEMPLATE_DETAIL: 'diagnostic-ancillary-template-detail',
  PATIENT_VISIT_PREVIEW_DATA_PRINT_LABEL: 'patient-visit-preview-data-print-label',
}
